// extracted by mini-css-extract-plugin
export default {"container":"SectionPedidosCadastrados_container__0hX8Y","containerCards":"SectionPedidosCadastrados_containerCards__UodPq"};